import React, { PureComponent } from 'react';
import { ContactBanner } from 'views/contact/subcomponents';
import { enableAnimations } from 'config/helpers';
import { Videos, Technologies, Experience } from './subcomponents';
import './Gitex.scss';

class Gitex extends PureComponent {
  componentDidMount() {
    enableAnimations();
  }

  render() {
    return (
      <div className={'single-page single-page--hero gitex'}>
        <Videos />
        <Technologies />
        <Experience />
        <ContactBanner />
      </div>
    );
  }
}

export default Gitex;
